import angular from "angular";
import { QueuedTasks } from "@common/model/QueuedTasks";
import * as _ from "lodash";
import * as toastr from "toastr";
import { TOAST_STATUS } from "@common/model/constants";
import { CacheService } from "@common/service/cache.service";
import { CommonService } from "@common/common.service";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { SnackbarService } from "@common/service/snackbar.service";
import { ILoggingService } from "@common/service/logging.service";
import { PushNotificationService } from "@common/service/push-notification.service";
import { BroadcastService } from "@common/service/broadcast.service";
import { LoggingDetail } from "@common/model/loggingDetail";
import { Util } from "@common/util";
import { IAppRootScopeService } from "@/app/app.definition";

    const MAX_RETRY: number = 10;
    const IDLE_DELAY = 500;

    export const TOASTID_PREFIX = 'doc-';
    export const TOAST_TEXT_PREFIX = 'text-';
    export class WebSocketService {
        public static webSocketObj;
        createSocket: Function;
        closeSocket: Function;
        getMultipleDocumentLink: Function;
        cancelDownload: Function;
        reset: Function;
        resetMltDwnld: Function;
        cnctChkInterval;
        currentUser;
        connected: boolean = false;
        currentRetryCount: number;
        maxConcurrencyLimit = 0;
        connectionId: string;
        staleConnectionId: string;
        bucketName: string;
        docArray: any[] = [];
        requestIds = {};
        cred: any;
        currentRegisterRetryCount: number;
        retryInterval: number;
        currentRetryInterval: number;
        maxRetryCount: number;
        uuid;
        hrtbeatInterval;
        recntTm;
        connect: Function;
        reconnect: Function;
        notificationTray: any[];
        inProcess: boolean;
        connectionTimeoutInterval = 0;
        documents = [];
        lastMessageSent = "";
        openingSocket = false;
        retryFnCall;
        tasks;
        toastPrefix;
        getTostId;
        getItemId;
        pswd;

        downloadMultiDoc = (documents: any, combineFlag): void => {
            this.startDwnldTasks(documents, combineFlag,false);
        }

        setDone = (itemId, deactivate) => {
            this.tasks.done(itemId, deactivate);
            let ind = this.docArray.findIndex(p => p == itemId);
            if (ind != -1) {
                this.docArray.splice(ind, 1);
            }
        }

        unloadFunction = (e) => {
            var context = this;

            if (!!context.docDwnldInProgress()) {
                var confirmationMessage = "Download is in progress. Are you sure you want to leave and cancel all downloads?";
                e.returnValue = confirmationMessage;
                return confirmationMessage;
            }
        }

        //To start the download tasks. This is called as soon as the user clicks multi download
        startDwnldTasks = (docs, combineFlag,isExport) => {
            var context = this;
            var data = [];
            if (!!context.connectionId && !!context.bucketName) {
                context.$rootScope.mainShowLoader = false;
                this.currentRetryCount = 1;
                this.tasks.maxConcurrencyLimit = this.CacheService.getMaxCncrntDwnld();
                var url = 'https://' + context.bucketName;
                const S3Obj = {
                    bucket: this.bucketName,
                    // "accessKeyId": context.cred.accessKeyId,
                    // "secretAccessKey": context.cred.secretKey,
                    // "sessionToken": context.cred.sessionToken,
                    "region": "us-east-1",
                    "httpOptions": {
                        "timeout": 900000
                    },
                    "s3BucketEndpoint": true,
                    "endpoint": url,
                    "signatureVersion": 'v4'
                };
                var combineUuid = null;
                var combineFileName = null;
                let toastId;
                if (combineFlag == null) {
                    for (let doc of docs) {
                        let itemId = context.getItemId(doc);
                        let ind = context.docArray.findIndex(p => p.id == itemId);
                        if (ind == -1) {
                            toastId = this.getTostId(itemId);
                            let elemId = "#" + toastId;
                            if (!!$(elemId).length) {
                                context.changeToastStatus(elemId, TOAST_STATUS.QUEUED);
                                //Open the notification tray
                                context.$rootScope.toggleNotificationTray(true);
                            } else {
                                var onCloseFunc = function () {
                                    console.log("CANCELLED-------: " + doc.id);
                                    context.$_snack.cleanup(context.getTostId(itemId));
                                    //if dwnld is cancelled before the response from backend comes, then it would never be added
                                    // in the tasks queue, hence the task needs to be changed to done here
                                    if (context.currentToastStatus(elemId) == TOAST_STATUS.QUEUED && !context.tasks.itemInQueue(itemId)) {
                                        context.setDone(itemId, false);
                                    }
                                    if (context.currentToastStatus(elemId) != TOAST_STATUS.FAILED) {
                                        //Call cancel api
                                        context.cancelDownload(doc.id);
                                        //Add into cancelled tasks
                                        context.tasks.cancel(itemId);
                                    }
                                }
                                let msg = `<i class='fa fa-download doc-action-icon'></i> ${isExport ?doc.fileName :doc.filename}  <div class='action-queued' id='${toastId}'><i id='progress-error-txt'>${isExport ?'failed. Please try again' : 'Download Failed'}</i><i id='queued-txt'>${isExport ? 'is being prepared for export':'Queued'}</i><div id='progressCntr'><div id='progressBar'></div></div></div>`;

                                context.$_snack.showDocDwnldToastr({ message: msg, notificationId: toastId }, onCloseFunc);
                                //Remove it from the cancelled tasks, if it was cancelled before
                                context.tasks.clearCancelled(itemId);

                            }
                            data.push({ "id": doc.id, "fileName": isExport ?doc.fileName:doc.filename, "signedCopy": doc.signedCopy, "isConvertedPdf": false, rawDocSize: doc.rawDocSize });
                            context.docArray.push(itemId);
                        }
                    }
                    this.tasks.totalItems += data.length;
                    //Call runTask only if it is not already running
                    if (data.length > 0 && this.tasks.totalItems == data.length) {
                        this.tasks.runTask();
                        window.addEventListener("beforeunload", context.unloadFunction, true);
                    }
                    data.forEach(d => { d.itemId = context.getItemId(d) });
                    this.documents = [...this.documents, ...data];
                }
                else {
                    combineUuid = this.$_comService.uuidv4();
                    var d = new Date();
                    combineFileName = "eCareVault_combined_document_" + d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + "_" + (d.getHours() * 60 * 60 + d.getMinutes() * 60 + d.getSeconds()) * 1000 + ".pdf";
                    var dobj = { id: combineUuid, signedCopy: false };
                    let itemId = context.getItemId(dobj);
                    toastId = this.getTostId(itemId) + "-" + combineFlag;;
                    let toastText = TOAST_TEXT_PREFIX + itemId;
                    let elemId = "#" + toastId;

                    var onCloseFunc = function () {
                        context.$_snack.cleanup(toastId);
                        if (context.currentToastStatus(elemId) == TOAST_STATUS.QUEUED && !context.tasks.itemInQueue(itemId)) {
                            context.setDone(itemId, false);
                        }
                        if (context.currentToastStatus(elemId) != TOAST_STATUS.FAILED) {
                            context.cancelDownload(combineUuid, true);
                            context.tasks.cancel(itemId);
                        }
                    }
                    let msg = "<i class='fa fa-download doc-action-icon'></i><span id='" + toastText + "'>" + combineFileName + "</span><div class='action-queued' id='" + toastId + "'><i id='progress-error-txt'>Download Failed</i><i id='queued-txt'>Queued</i><i id='warning-msg'></i><div id='progressCntr'><div id='progressBar'></div></div></div>";
                    context.$_snack.showDocDwnldToastr({ message: msg, notificationId: toastId }, onCloseFunc);
                    context.tasks.clearCancelled(itemId);

                    let ids = [];
                    for (let doc of docs) {
                        ids.push(doc.id);
                    }
                    data = docs;
                    context.requestIds[combineUuid] = ids;
                    context.docArray.push(itemId);
                    this.tasks.totalItems += 1;
                    //Call runTask only if it is not already running
                    if (data.length > 0 && this.tasks.totalItems == 1) {
                        this.tasks.runTask();
                        window.addEventListener("beforeunload", context.unloadFunction, true);
                    }
                }
                if (data.length > 0 && !isExport) {
                    context.getMultipleDocumentLink(data, combineUuid, combineFileName, toastId);
                }
            } else {
                context.retryFnCall(context.startDwnldTasks, docs, combineFlag,isExport);
            }
        }
        //Show error on toast if download fails
        showErrorToast = (toastId?, warningMsg?) => {
            if (!!toastId) {
                if (!!$("#" + toastId).length) {
                    this.changeToastStatus("#" + toastId, TOAST_STATUS.FAILED);
                } else {
                    if (!!$("#" + toastId + "-print").length) {
                        toastId = toastId + "-print";
                    } else if (!!$("#" + toastId + "-download").length) {
                        toastId = toastId + "-download";
                    }
                    this.showWarningToast(toastId, warningMsg)
                }
            } else {
                for (let itemId of this.docArray) {
                    let tId = "#" + this.getTostId(itemId);
                    if (this.currentToastStatus(tId) == TOAST_STATUS.QUEUED && !this.tasks.itemInQueue(itemId)) {
                        this.changeToastStatus(tId, TOAST_STATUS.FAILED);
                        this.setDone(itemId, false);
                    }
                }
            }
        }

        //Show warning on toast for combine document
        showWarningToast = (toastId, warningMsg, isWarningMsg = true) => {
            var elemId = "#" + toastId;
            var id = (isWarningMsg ? "warning-msg" : "queued-txt");
            var elem = $(elemId).find('#' + id);
            elem[0].innerHTML = (isWarningMsg ? `<i class='fa fa-exclamation-triangle'></i> ` : '') + warningMsg;
            let pr = $(elemId).parents('.ecv-toast-doc');
            let closeBtn = pr.find(".fa-trash");
            closeBtn.removeClass("fa-trash");
            closeBtn.addClass("fa-times");
            isWarningMsg && this.changeToastStatus(elemId, TOAST_STATUS.WARNING)
        }

        //Changes the status of the toast msgs - Queued, In Progress or Failed
        changeToastStatus = (elemId, status) => {
            $(elemId).removeClass();
            $(elemId).addClass(status);
        }

        currentToastStatus = (elemId) => {
            return $(elemId).attr('class');
        }

        docDwnldInProgress = () => {
            let inProgress = false;
            let doc_toastr = $('#toast-container-main').find('div[id^="doc-"]');
            doc_toastr.each((index, dt) => {
                if (this.currentToastStatus('#' + dt.id) != TOAST_STATUS.FAILED) {
                    inProgress = true;
                    return false; // break the loop
                }
            });
            return inProgress;
        }

        static $inject = ["CacheService", "CommonService", "ApiAdapterService",
            "SnackbarService", "$timeout", "$rootScope", "LoggingService", "$interval", "PushNotificationService", "authConfig", "storageConfig","BroadcastService", "ecareEnv"];
        logDetail: LoggingDetail;
        constructor(private CacheService: CacheService,
            private $_comService: CommonService,
            private ApiAdapterService: JavaApiAdapterService,
            private $_snack: SnackbarService,
            private $timeout: angular.ITimeoutService,
            private $rootScope: IAppRootScopeService,
            private $_log: ILoggingService,
            private $interval: angular.IIntervalService,
            private PushNotificationService: PushNotificationService,
            private authConfig: any,
            private storageConfig: any,
            private BroadcastService: BroadcastService,
            private ecareEnv: string) {

            this.notificationTray = [];
            this.maxRetryCount = 10;
            this.currentRetryCount = 1;
            this.tasks = new QueuedTasks();

            this.tasks.action = (params) => {
                let context = this;
                if (!!context.tasks.isCancelled(params.itemId)) {
                    context.setDone(params.itemId, true);
                } else {
                    let toastId = context.getTostId(params.itemId);
                    var combineFlag = null;
                    var fileName = "";
                    var docIndex = -1;
                    var docSize = -1;
                    var events = context.$_log.events;
                    if (!!$("#" + toastId).length) {
                        combineFlag = null;
                        docIndex = context.documents.findIndex(d => d.itemId == params.itemId);
                        if (docIndex != -1) {
                            fileName = context.documents[docIndex].fileName;
                            docSize = context.documents[docIndex].rawDocSize;
                        } else {
                            console.log("Document does not found.")
                        }
                    } else if (!!$("#" + toastId + "-print").length) {
                        toastId = toastId + "-print";
                        combineFlag = "print";
                    } else if (!!$("#" + toastId + "-download").length) {
                        let toastText = TOAST_TEXT_PREFIX + params.itemId;
                        // let arrSizes = [];
                        let elemId = "#" + toastText;
                        let elem = $(elemId)[0];

                        fileName = elem.textContent
                        toastId = toastId + "-download";
                        combineFlag = "download";
                        docSize = params.rawDocSize;
                    }

                    var logDetails = (prms, event, startTime, endTime, flag) => {
                        var idToLog, requestIdToLog, docIdsToLog;
                        if (combineFlag == null) {
                            idToLog = prms.id;
                            requestIdToLog = null;
                            docIdsToLog = null;
                        } else {
                            idToLog = null;
                            requestIdToLog = prms.id;
                            docIdsToLog = context.requestIds[prms.id];
                        }
                        context.logDetail = new LoggingDetail(event, idToLog, startTime, endTime, flag, requestIdToLog, docIdsToLog);
                        context.$_log.logAction(context.logDetail);
                        delete context.requestIds[prms.id]
                    };

                    var postDownload = () => {
                        if (combineFlag == null) {
                            context.documents.splice(docIndex, 1);
                        }
                    };

                    let p = {
                        Bucket: params.Bucket,
                        Key: params.Key
                    };
                    const sassData = this.CacheService.getSASSToken();
                    var signedUrl = params.notificationType == "EXPORT_FILE_DOWNLOAD" ? `${this.storageConfig.url}/${params.Bucket}/${params.Key}?${sassData.sasToken}` : `${this.storageConfig.url}/${context.bucketName}/${params.Key}?${sassData.sasToken}`;

                    if (docSize > Util.DOCSIZE_THRESOLD) {
                        if (!context.tasks.isCancelled(params.itemId)) {
                            if (isIE11) {
                                context.setDone(params.itemId, true);
                                logDetails(params, events.IE_LG_DOC_DENIED, Date.now(), null, true);
                                context.showWarningToast(toastId, Util.IE_DOWNLOAD_NOT_ALLOWED_LG_DOC, false);
                            } else {
                                var frameSrc = `${this.storageConfig.url}/${context.bucketName}`;
                                context.$_comService.downloadViaBrowser(signedUrl, fileName, frameSrc);
                                context.setDone(params.itemId, true);
                                logDetails(params, events.BROWSER_DOWNLOAD, Date.now(), null, true);
                                context.showWarningToast(toastId, Util.LG_DOC_DOWNLOAD_TRAY_MESSAGE, false);
                            }
                            context.$timeout(function () {
                                //hide tray notification after 10 seconds
                                context.$_snack.clearNotificationToastr(toastId);
                            }, 10000);
                            postDownload();
                        }
                    } else {
                        try {
                            var startTime = Date.now();
                            var req = new XMLHttpRequest();
                            req.open("GET", signedUrl, true);
                            req.responseType = "blob"; //Arraybuffer
                            req.addEventListener("progress", function (evt) {
                                //console.log("Download in progress : " + Math.floor((evt.loaded * 100) / evt.total)+'%');
                                if (context.tasks.isCancelled(params.itemId)) {
                                    console.log("ABORTED: ", params.itemId);
                                    req.abort();
                                }
                                var elemId = "#" + toastId;
                                var elem = $(elemId).find('#progressBar');
                                context.changeToastStatus(elemId, TOAST_STATUS.IN_PROGRESS);
                                var width = Math.floor((evt.loaded * 100) / evt.total);
                                elem.css({ "width": width + '%' });
                                elem.html(width * 1 + '%');
                            }, false);
                            req.onerror = function (evt) {
                                context.setDone(params.itemId, true);
                                if (req.response) {
                                    context.showErrorToast(toastId);
                                    logDetails(params, events.DOWNLOAD_DOC, startTime, Date.now(), false);
                                    return;
                                }
                            };
                            req.onload = function (evt) {
                                context.setDone(params.itemId, true);
                                params.notificationType != "EXPORT_FILE_DOWNLOAD"  && logDetails(params, events.DOWNLOAD_DOC, startTime, Date.now(), true);
                                //error msg from backend
                                if (!!params.message) {
                                    context.showWarningToast(toastId, params.message)
                                } else {
                                    context.$timeout(function () {
                                        context.$_snack.clearNotificationToastr(toastId);
                                        params.notificationType == "EXPORT_FILE_DOWNLOAD" && BroadcastService.broadcast('enable-download-btn');
                                    }, 100);
                                }
                                var content = req.response || (evt.currentTarget as XMLHttpRequest).response;
                                if (!context.tasks.isCancelled(params.itemId)) {
                                    context.$_comService.downloadDocument(fileName, params.keywords, content, false, combineFlag)
                                    postDownload();
                                }
                            }
                            req.send();
                        } catch (e) {
                            console.error(e);
                        }
                    }
                }
            }

            this.getTostId = (itemId) => {
                return TOASTID_PREFIX + itemId;
            }

            this.getItemId = (obj) => {
                return (`${obj.id}${obj.signedCopy ? "-" + obj.signedCopy : ""}`);
            }

            this.createSocket = () => {
                var context = this;
                console.log("SOCKET CREATION :: ", this.openingSocket);
                if (!!this.openingSocket) {
                    return;
                }
                this.openingSocket = true;
                this.currentRegisterRetryCount = 1;
                this.retryInterval = 1000;
                this.currentRetryInterval = this.retryInterval;
                this.currentUser = CacheService.getUser();
                this.pswd = CacheService.getPassword();
                var pushNotifications = CacheService.getPushNotifications();
                if (!!pushNotifications && pushNotifications.length > 0) {
                    this.lastMessageSent = pushNotifications[0].lastMessageSent;
                }

                if (!!WebSocketService.webSocketObj) {
                    context.openingSocket = false;
                    console.log("Already connected to the push notification service.");
                } else {
                    var callBack = () => {
                        console.log("CALLBACK::", context.notificationTray.length);
                        if (context.notificationTray.length > 0) {
                            var notification = context.notificationTray.splice(0, 1)[0];
                            context.PushNotificationService.processNotification(notification).finally(() => {
                                callBack();
                            });
                        } else {
                            context.inProcess = false;
                        }

                    }
                    $interval.cancel(context.cnctChkInterval);

                    ApiAdapterService.getWSUrl().then(wsCnf => {

                        WebSocketService.webSocketObj = new WebSocket(wsCnf.url, 'json.webpubsub.azure.v1');

                        // /**********Websocket ONOPEN ********************/
                        WebSocketService.webSocketObj.onopen = function (event) {
                            console.log("Connection Opened");
                        };

                        // /**********Websocket ONCLOSE ********************/
                        WebSocketService.webSocketObj.onclose = function (event) {
                            console.log("Connection closed", event);
                            if (!!WebSocketService.webSocketObj || !!this.connected) {
                                if (WebSocketService.webSocketObj.readyState == WebSocket.CLOSED) {
                                    WebSocketService.webSocketObj = null;
                                    this.connected = false;
                                    context.connectionId = null;
                                    context.uuid = null;
                                }
                            }
                        };

                        // /**********Websocket ONERROR ********************/
                        WebSocketService.webSocketObj.onerror = function (event) {
                            console.error("WebSocket error observed:", event);
                        };

                        // /**********Websocket ONMESSAGE ********************/
                        WebSocketService.webSocketObj.onmessage = function (event) {
                            var response = {};
                            var respData: any = {};
                            try {
                                response = JSON.parse(event.data);
                                respData = response['data'];
                                console.log("RESPONSE ::: ", response);
                            } catch (e) {
                                console.log("Error occured while parsing notification");
                            }

                            if (Object.keys(response).length > 0) {
                                if (response['event'] == "connected") {
                                    context.connectionId = response['connectionId'];
                                    context.connect();
                                    context.connected = true;
                                    context.currentRegisterRetryCount = 1;
                                    context.currentRetryInterval = this.retryInterval;

                                    //Check if uuid is available or else register again
                                    context.cnctChkInterval = $interval(() => {
                                        console.log("CHCK INT");
                                        if (!context.uuid) {
                                            context.connect();
                                        }
                                    }, 60 * 1000);
                                }
                                else if (!!respData.bucketName && !!respData.connectionId && !!respData.uuid) {
                                    context.connected = true;
                                    context.openingSocket = false;
                                    context.currentRegisterRetryCount = 1;
                                    context.retryInterval = 1000;
                                    context.currentRetryInterval = context.retryInterval;
                                    context.connectionId = respData.connectionId;
                                    context.staleConnectionId = respData.connectionId;
                                    context.bucketName = respData.bucketName;
                                    context.uuid = respData.uuid;
                                    $interval.cancel(context.cnctChkInterval);
                                } else if (respData.notificationType == "DOWNLOAD" || respData.notificationType == "EXPORT_FILE_DOWNLOAD") {
                                    const params = {
                                        id: respData.id,
                                        Bucket: respData.notificationType == "EXPORT_FILE_DOWNLOAD"? respData.bucketName :context.bucketName.replace("ecv-dev", "dev"),
                                        Key: respData.notificationType == "EXPORT_FILE_DOWNLOAD"? respData.fileName :context.currentUser.providerIdentity + '/' + respData.fileName,
                                        itemId: context.getItemId(respData),
                                        filename: respData.fileName,
                                        keywords: respData.keywords,
                                        ext: respData.ext,
                                        notificationType:respData.notificationType
                                    };
                                    context.tasks.add(params);
                                } else if (respData.notificationType == "COMBINE") {
                                    const params = {
                                        id: respData.combinePdfRequestId,
                                        Bucket: context.bucketName.replace("ecv-dev", "dev"),
                                        Key: context.currentUser.providerIdentity + '/' + respData.fileName,
                                        itemId: context.getItemId({ id: respData.combinePdfRequestId, signedCopy: respData.signedCopy }),
                                        filename: respData.fileName,
                                        keywords: respData.keywords,
                                        ext: respData.ext,
                                        message: (!!respData.message) ? respData.message : null,
                                        rawDocSize: respData.rawDocSize
                                    };
                                    context.tasks.add(params);
                                } else if (respData.notificationType == "PUSHNOTIFICATION" && respData.event!="FAILURE") {
                                    context.lastMessageSent = respData.lastMessageSent;
                                    if (!context.inProcess) {
                                        context.inProcess = true;
                                        context.PushNotificationService.processNotification(respData).finally((s) => {
                                            callBack();
                                        });
                                    } else {
                                        context.notificationTray.push(respData);
                                    }
                                } else if (!!respData.errorCode || respData.event=="FAILURE") {       //Error Handling
                                    if (!!respData.objectId||!!respData.additionalProperties.uuid) {
                                        var flag = (_.isNil(respData.additionalProperties) || _.isNil(respData.additionalProperties.signedCopy)) ? false : respData.additionalProperties.signedCopy;
                                        let d
                                        if(respData.entity=="EXPORT_FILE_DOWNLOAD"){
                                            d = { id: respData.additionalProperties.uuid};
                                            context.BroadcastService.broadcast('enable-download-btn')
                                        }else{
                                              d = { id: respData.objectId, signedCopy: flag };
                                        }
                                        let itemId = context.getItemId(d);
                                        let toastId = context.getTostId(itemId);
                                        let errMessage = respData.errorMessage || respData.message;
                                        context.showErrorToast(toastId, errMessage);
                                        context.setDone(itemId, false);
                                    } else if (respData.errorCode == '502') { //
                                        context.currentRetryInterval = context.retryInterval * Math.pow(2, context.currentRegisterRetryCount);
                                        if (context.currentRegisterRetryCount <= context.maxRetryCount) {
                                            console.log("Reconnecting in " + context.currentRetryInterval + "ms");
                                            setTimeout(() => {
                                                context.currentRegisterRetryCount = context.currentRegisterRetryCount + 1;
                                                context.connect();
                                            }, context.currentRetryInterval);
                                        } else {
                                            console.log("Unable to connect to the push notification service.");
                                        }
                                    } else {      //Error when connecting to socket
                                        context.showErrorToast();
                                    }
                                } else {
                                    console.log("Received internal error from gateway");
                                }
                            }
                        }

                    })


                }
            }

            this.connect = () => {
                var context = this;
                this.currentRegisterRetryCount = 1;
                this.currentRetryInterval = this.retryInterval;
                if (!!WebSocketService.webSocketObj && !!context.currentUser) {
                    let sendMsg = {
                        "type": "event",
                        "event": "register",
                        "dataType": "json",
                        "data": {
                            "userId": context.currentUser.userId,
                            "password": context.pswd,
                            "connectionId": context.connectionId,
                            "staleConnectionId": context.staleConnectionId,
                            "lastMessageSent": context.lastMessageSent
                        }
                    };
                    WebSocketService.webSocketObj.send(JSON.stringify(sendMsg));
                } else {
                    this.reset();
                }
            }

            this.reconnect = () => {
                WebSocketService.webSocketObj.close(4001);
                WebSocketService.webSocketObj = null;
                this.connected = false;
                this.connectionId = null;
                this.uuid = null;
                this.bucketName = null;
                this.createSocket();
            }

            //Call to get the document link
            this.getMultipleDocumentLink = (docs: any[], combineUuid, combineFileName, toastId) => {
                var context = this;
                if (!!WebSocketService.webSocketObj && !!context.uuid && !!context.bucketName) {
                    this.currentRetryCount = 1;
                    let sendMsg;
                    if (combineUuid == null) {
                        sendMsg = {
                            "type": "event",
                            "event": "download",
                            "dataType": "json",
                            "data": {
                                "docs": docs,
                                "userId": context.currentUser.id,
                                "password": CacheService.getPassword(),
                                "isMobile": true,
                                "uuid": context.uuid,
                                "cognitoIdentityId": context.currentUser.providerIdentity
                            }
                        };
                    } else {
                        sendMsg = {
                            "type": "event",
                            "dataType": "json",
                            "event": "combine",
                            "data": {
                                "docs": docs,
                                "userId": context.currentUser.id,
                                "password": CacheService.getPassword(),
                                "isMobile": true,
                                "uuid": context.uuid,
                                "cognitoIdentityId": context.currentUser.providerIdentity,
                                "combinePdfRequestId": combineUuid
                            }
                        };
                    }
                    if (!!navigator.onLine) {
                        WebSocketService.webSocketObj.send(JSON.stringify(sendMsg));
                    } else if (combineUuid == null) {
                        docs.forEach((x) => {
                            let itemId = context.getItemId(x);
                            context.showErrorToast(context.getTostId(itemId));
                            context.setDone(itemId, false)
                        })
                    } else {
                        context.showErrorToast(toastId);
                        context.setDone(context.getItemId({ id: toastId, signedCopy: false }), false)
                    }

                } else {
                    context.retryFnCall(context.getMultipleDocumentLink, docs, combineUuid, combineFileName, toastId);
                }

            }

            this.retryFnCall = (fn, params) => {
                var context = this;
                if (this.currentRetryCount == 1) {
                    this.currentRetryCount++;
                    setTimeout(function () {
                        fn(params);
                    }, 3000);
                } else {
                    if (this.currentRetryCount <= MAX_RETRY) {
                        this.currentRetryCount++;
                        this.createSocket();
                        setTimeout(function () {
                            fn(params);
                        }, IDLE_DELAY);
                    } else {
                        context.$rootScope.mainShowLoader = false;
                        context.showErrorToast();
                        //context.resetMltDwnld();
                        toastr.success("Something went wrong. Please try again later.");
                    }
                }
            }

            this.cancelDownload = (docId: number, isCombinePDF = false) => {
                var context = this;
                if (!!WebSocketService.webSocketObj) {
                    let sendMsg = {
                        "type": "event",
                        "dataType": "json",
                        "event": "cancel",
                        "data": {
                            "uuid": context.uuid
                        }
                    }
                    if (isCombinePDF) {
                        sendMsg["data"]["combinePdfRequestId"] = docId;
                    } else {
                        sendMsg["data"]["docId"] = docId;
                    }

                    WebSocketService.webSocketObj.send(JSON.stringify(sendMsg));
                }

            }

            //To disconnect the socket
            this.closeSocket = () => {
                var context = this;
                if (!!WebSocketService.webSocketObj && !!this.connected) {
                    WebSocketService.webSocketObj.close(4001);
                }
                console.log("WEBSOCKET CLOSED");
                WebSocketService.webSocketObj = null;
                this.connected = false;
                this.connectionId = null;
                this.uuid = null;
                this.openingSocket = false;
                $interval.cancel(context.cnctChkInterval);
                window.removeEventListener("beforeunload", this.unloadFunction, true);

            }

            //To re-initialize all variables
            this.reset = () => {
                this.closeSocket();
                this.currentUser = null;
                this.currentRetryCount = 0;
                this.maxConcurrencyLimit = 0;
                this.connectionId = null;
                this.uuid = null;
                this.bucketName = null;
                this.docArray = [];
                this.tasks.totalItems = 0;
            }

            //To re-initialize all variables related to multiple dwnld
            this.tasks.resetAction = () => {
                this.currentRetryCount = 0;
                this.maxConcurrencyLimit = 0;
                this.docArray = [];
                this.tasks.totalItems = 0;
            }

        }
    }

    angular.module('eCareVault.common.services')
        .service('WebSocketService', WebSocketService);
